import { LICENSE_TYPE_DEFS } from '../../tn.common/constants';

export function cleanCartFontRights(fontRights) {
    // Contains only rights with values
    const activeRights = {};

    Object.keys(fontRights).forEach((licenseType) => {
        // epub is currently not supported for sale.
        // TODO: this shoudl be drive by the foundry bucket.
        if (licenseType == 'epub') return;
        const def = LICENSE_TYPE_DEFS[licenseType];
        // if the license type is not defined, don't include it.
        if (!def) return;
        const right = fontRights[licenseType];
        // if the right is not defined, don't include it. this shouldn't ever be true.
        if (!right) return;
        if (!right[def.key]) return;
        activeRights[licenseType] = fontRights[licenseType];
    });

    return activeRights;
}

export function CleanCartFontRightsFilter() {
    return cleanCartFontRights;
}
